import { render, staticRenderFns } from "./ModalAdminUser.vue?vue&type=template&id=bad52b1c&scoped=true"
import script from "./ModalAdminUser.vue?vue&type=script&lang=js"
export * from "./ModalAdminUser.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminUser.vue?vue&type=style&index=0&id=bad52b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad52b1c",
  null
  
)

export default component.exports